module.exports = __webpack_public_path__ + "static/media/slider-l2-360.ccf13c57.webp";